import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import { Grid } from '@material-ui/core';
import VISA from "../../assets/image/VISA.png";
import MC from "../../assets/image/MC.png";
import DISC from "../../assets/image/DISC.png";
import DINERS_CLUB from "../../assets/image/DINERS_CLUB.png";
import JCB from "../../assets/image/JCB.png";
import AMEX from "../../assets/image/AMEX.png";
import InputMask from 'react-input-mask';
import '../Pages/page.css'
import { getVisitorPermitCardType } from '../../store/visitorPermit/selector';
import { useSelector } from 'react-redux';
const useStyles = makeStyles((theme) => ({
  textField: {
    "& div input": {
      padding: "7px 12px 10px",
    },
    width: "100%",
  },
  img: {
    width: 40,
    height: 25
    //   height:100
  }
}));

const CreditCardText = (props) => {
  const [permitCardType, setPermitCardType] = React.useState(false);

  const getVisitorPermitCardTypeList = useSelector(getVisitorPermitCardType);
  const { label, onChange, value, name, id, autoComplete } = props;
  const inputId = id || name || "filled-basic";


  React.useEffect(() => {
    setPermitCardType(getVisitorPermitCardTypeList?.acceptedCardTypes);
  }, [getVisitorPermitCardTypeList]);


  const classes = useStyles()
  return (
    <>
      <div display="flex" justify="space-between">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} justify="space-between">
          <label htmlFor={inputId}>{label || ""}</label>
          <div className='payment-box'>
            {permitCardType && permitCardType.map((ele) => {
              return <img src={ele == 'VISA' ? VISA : ele == 'MC' ? MC : ele == 'DINERS_CLUB' ? DINERS_CLUB : ele == 'JCB' ? JCB : ele == 'AMEX' ? AMEX : ele == 'DISC' ? DISC : ''} alt={`${ele} accepted`} className="payment-img" />
            })}
          </div>
        </div>



        <InputMask mask='9999 9999 9999 9999' maskChar={null} value={value} onChange={onChange}>
          {(inputProps) => <TextField
            id={inputId}
            variant="filled"
            className={classes.textField}
            name={name}
            value={value || ""}
            onChange={onChange}
            autoComplete={autoComplete || "off"}
            {...inputProps}
          />}
        </InputMask>

      </div>
    </>
  );
};

export default CreditCardText;